<div class="host ___dashboard page"  *ngIf="page$ | async as page; else loadingView">

  <div class="main" *ngIf="page.data as data; else notFound">
  <ng-container *ngIf="data.part; let part">
    
    <div class="head">
  
      <div class="title">
        <h1>{{ isNew ? 'Add New ' : 'Update' }} {{ part.name }}</h1>
        <ng-container *ngIf="part.name !== 'profile'">
          <a
            style="margin-right: .5rem;"
            class="button-outline-primary"
            [usefulRouterLink]="['app-dashboard', 'list', part.name]"
            [usefulRouteQueryParams]="{type: !activeType ? 'default' : activeType}"
          >All {{ part.menuItem.text || 'Items' }}</a>
          <a
            *ngIf="!isNew"
            class="button-outline-primary"
            [usefulRouterLink]="['app-dashboard', 'new', part.name]"
            [usefulRouteExtras]="{queryParams: {type: !databaseItem ? 'default' : databaseItem.type}}"
          >Add another</a>
          <a
            *ngIf="!isNew && databaseItem"
            class="button-outline-primary"
            [usefulRouterLink]="['app-dashboard', 'copy', part.name, databaseItem.id]"
          >Add similar</a>
        </ng-container>
      </div>
  
    </div>
  
    <div class="body">
  
      <form
        [formGroup]="data.formGroup"
        (ngSubmit)="submit(part, data.formGroup)"
        (keydown.enter)="false"
        #theForm="ngForm"
      >
        <ng-container *ngFor="let schema of data.formSchema">
        <div class="item" [class.required]="!!schema.required" *ngIf="!schema.hidden">
  
          <div class="schema-label">
            <label class="form-label" [for]="schema.name">{{ schema.label }}</label>
            <a
              href="#"
              class="desc-toggler"
              *ngIf="schema.description"
              (click)="activeDescriptions[schema.name]=!activeDescriptions[schema.name];false;"
            >Description {{ !activeDescriptions[schema.name] ? '▼' : '▲' }}</a>
          </div>
          <div
            class="schema-description"
            [class.active]="activeDescriptions[schema.name]"
            *ngIf="schema.description"
            [innerHtml]="schema.description"
          ></div>
  
          <ng-container
            *ngIf="
              schema.type==='text' ||
              schema.type==='number'
            "
          >
            <input
              class="form-control"
              [id]="schema.name"
              [type]="schema.type"
              [formControlName]="schema.name"
              [placeholder]="schema.placeholder || ''"
            >
          </ng-container>
  
          <ng-container *ngIf="schema.type==='textarea'">
            <textarea
              class="form-control"
              [id]="schema.name"
              [formControlName]="schema.name"
              [placeholder]="schema.placeholder || ''"
            ></textarea>
          </ng-container>
  
          <ng-container *ngIf="schema.type==='checkbox'">
          <div class="checkboxes">
              <label class="form-checkbox" *ngFor="let checkboxItem of schema.children || []">
                <input
                  type="checkbox"
                  (change)="checkboxChanges(
                    schema,
                    data.formGroup,
                    schema.children || [],
                    checkboxItem,
                    $event
                  )"
                  [checked]="checkboxItem.checked"
                >
                <span>{{ checkboxItem.text }}</span>
              </label>
          </div>
          </ng-container>

          <ng-container *ngIf="schema.type==='radio'">
          <div class="radios">
            <label class="form-radio" *ngFor="let radioItem of schema.selections || []">
              <input
                type="radio"
                (change)="radioChanges(
                  schema,
                  data.formGroup,
                  schema.selections || [],
                  radioItem
                )"
                [checked]="radioItem.selected"
              >
              <span>{{ radioItem.text }}</span>
            </label>
          </div>
          </ng-container>
  
          <ng-container *ngIf="schema.type==='select'">
            <select class="form-select" [id]="schema.name" [formControlName]="schema.name">
              <option *ngIf="schema.placeholder" value="0" disabled="true">{{ schema.placeholder }}</option>
              <option
                *ngFor="let radioItem of schema.selections || []"
                [value]="radioItem.value"
                [selected]="radioItem.selected"
              >{{ radioItem.text }}</option>
            </select>
          </ng-container>
  
          <ng-container *ngIf="schema.type==='type' && part.contentTypes">
            <select class="form-select" [id]="schema.name" [formControlName]="schema.name">
              <option *ngFor="let type of part.contentTypes" [value]="type.value">{{ type.text }}</option>
            </select>
          </ng-container>
  
          <ng-container *ngIf="schema.type==='status'">
            <select class="form-select" [id]="schema.name" [formControlName]="schema.name">
              <option value="publish">Publish</option>
              <option value="draft">Draft</option>
            </select>
          </ng-container>
  
          <ng-container *ngIf="schema.type==='locale'">
            <select class="form-select" [id]="schema.name" [formControlName]="schema.name">
              <option
                *ngFor="let localeItem of settingService.locales"
                [value]="localeItem.value"
              >{{ localeItem.text }}</option>
            </select>
          </ng-container>

          <ng-container *ngIf="schema.type==='upload'">
            <div class="uploadable">
              <input
                class="form-control"
                type="text"
                [id]="schema.name"
                [formControlName]="schema.name"
                [placeholder]="schema.placeholder || ''"
              >
              <a
                href="#"
                class="button-outline-primary"
                (click)="
                  openUploader(
                    schema,
                    data.formGroup,
                    schema.meta?.imageCropping
                  );
                  false;
                "
              >Upload</a>
            </div>
          </ng-container>
  
          <ng-container *ngIf="schema.type==='content'">
          <ng-container *ngIf="schema.meta as ceData">
            <div class="content-editor" [class.allow-direct]="ceData.allowDirect">
              <label class="toggler" *ngIf="ceData.allowDirect">
                <input
                  type="checkbox"
                  [checked]="ceData.isDirect"
                  (change)="ceData.isDirect=!ceData.isDirect"
                >
                <span>Direct</span>
              </label>
              <ng-container
                *ngIf="
                  ceData.allowDirect &&
                  ceData.isDirect &&
                  ceData.contentHtml;
                  else indirectContent;
                "
              >
                <nguix-dashboard-html-editor
                  [htmlContent]="ceData.contentHtml"
                  (save)="htmlChanges(
                    schema,
                    data.formGroup,
                    $event
                  )"
                ></nguix-dashboard-html-editor>
              </ng-container>
              <ng-template #indirectContent>
                <input
                  class="form-control"
                  [id]="schema.name"
                  type="text"
                  [formControlName]="schema.name"
                  [placeholder]="schema.placeholder || ''"
                >
              </ng-template>
            </div>
          </ng-container>
          </ng-container>

          <ng-container *ngIf="schema.type==='html' && schema.meta">
            <nguix-dashboard-html-editor
              [htmlContent]="schema.meta.htmlContent"
              (save)="htmlChanges(
                schema,
                data.formGroup,
                $event
              )"
            ></nguix-dashboard-html-editor>
          </ng-container>
  
          <ng-container *ngIf="schema.type==='json' && schema.meta">
            <nguix-dashboard-json-editor
              [type]="schema.meta.type"
              [currentData]="schema.meta.currentData"
              [schema]="schema.meta.schema"
              [recordKey]="schema.meta.recordKey"
              (save)="jsonChanges(
                schema,
                data.formGroup,
                $event
              )"
            ></nguix-dashboard-json-editor>
          </ng-container>
  
          <ng-container *ngIf="schema.type==='link' && schema.meta">
            <nguix-dashboard-link-editor
              [formGroup]="data.formGroup"
              [currentData]="schema.meta.currentData"
              [sourcePart]="part"
              [destinationPart]="schema.meta.part"
              [preload]="schema.meta.preload"
              [activeLocale]="activeLocale"
              [activeType]="activeType"
              [typeFilter]="schema.meta.typeFilter"
              (save)="linkChanges(
                schema,
                data.formGroup,
                $event
              )"
            ></nguix-dashboard-link-editor>
          </ng-container>

          <ng-container *ngIf="schema.type==='list' && schema.meta">
            <nguix-dashboard-list-editor
              [currentData]="schema.meta.currentData"
              (save)="listChanges(
                schema,
                data.formGroup,
                $event
              )"
            ></nguix-dashboard-list-editor>
          </ng-container>

          <ng-container *ngIf="schema.type==='tag' && schema.meta">
            <nguix-dashboard-tag-editor
              [formGroup]="data.formGroup"
              [currentData]="schema.meta.currentData"
              [sourcePart]="part"
              [destinationPart]="schema.meta.part"
              [preload]="schema.meta.preload"
              [activeLocale]="activeLocale"
              [activeType]="activeType"
              [typeFilter]="schema.meta.typeFilter"
              (save)="tagChanges(
                schema,
                data.formGroup,
                $event
              )"
            ></nguix-dashboard-tag-editor>
          </ng-container>

          <div class="schema-note" *ngIf="schema.note" [innerHtml]="schema.note"></div>
  
        </div>
        </ng-container>

        <div class="optional">
          <label class="form-checkbox" *ngIf="!isNew && !isCopy && !isTranslate">
            <input type="checkbox" (change)="updateWithAdvancedCreationChanges($event)">
            <span>Update with advanced creation</span>
          </label>
        </div>
  
        <div class="actions">

          <div
            class="primary"
            *ngIf="isNew || databaseItem?.status==='draft' || databaseItem?.status==='publish'"
          >
            <div class="left">
              <button
                class="submit button-primary"
                type="submit"
                [disabled]="!theForm.form.valid || lockdown"
              >{{ submitText }}</button>
            </div>
            <div class="right">
              <a
                class="preview button-outline-primary"
                [class.disabled]="!theForm.form.valid || lockdown"
                href="javascript:void(0)"
                (click)="
                  !theForm.form.valid || lockdown
                    ? false
                    : dataService.previewItem(part)
                "
              >Preview</a>
            </div>
          </div>

          <div class="secondary" *ngIf="part.name !== 'profile' && databaseItem && !isCopy">

            <ng-container
              *ngIf="databaseItem.status==='draft' || databaseItem.status==='publish'"
            >
              <div class="left">
                <a
                  class="archive button-dark"                
                  href="javascript:void(0)"
                  (click)="dataService.archiveItem(part, databaseItem)"
                >Archive</a>
              </div>
              <div class="right">                
                <a
                  class="delete button-outline-danger"
                  href="javascript:void(0)"
                  (click)="remove(part, databaseItem)"
                >Delete</a>
                <a
                  class="trash button-danger"
                  href="javascript:void(0)"
                  (click)="dataService.trashItem(part, databaseItem)"
                >Trash</a>
              </div>
            </ng-container>
    
            <ng-container *ngIf="databaseItem.status==='archive'">
              <div class="left">
                <a
                  class="unarchive button-success"
                  href="javascript:void(0)"
                  (click)="dataService.unarchiveItem(part, databaseItem)"
                >Unarchive</a>
              </div>
            </ng-container>
  
            <ng-container *ngIf="databaseItem.status==='trash'">
              <div class="left">
                <a
                  class="trash button-success"
                  href="javascript:void(0)"
                  (click)="dataService.restoreItem(part, databaseItem)"
                >Restore</a>  
              </div>
            </ng-container>
  
          </div>
  
        </div>
  
      </form>
  
    </div>

  </ng-container>
  </div>
  
  <ng-template #notFound>
    <div class="not-found">Not found ...</div>
  </ng-template>
</div>

<ng-template #loadingView>
  <div class="loading">
    <nguix-dashboard-spinner></nguix-dashboard-spinner>
  </div>
</ng-template>

<nguix-dashboard-uploader
  [show]="showUploader"
  [closeOnCompleted]="true"
  [imageCropping]="uploadCallerData?.imageCropping"
  (close)="showUploader=false;uploadCallerData=undefined;"
  (done)="uploadChanges($event)"
></nguix-dashboard-uploader>
